import PriceAddOrUpdateContent from "../content/PriceAddOrUpdateContent";
import Layout from "../layout/Layout";

const CityTarriffsAdd = () => {
  return (
    <Layout>
      <PriceAddOrUpdateContent />
    </Layout>
  );
};

export default CityTarriffsAdd;
